/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AdvancedReportsAgentProfileMode {
    AGENTS_ONLY = 'agents-only',
    ACTIVE_USERS_ONLY = 'active-users-only',
    ALL_USERS = 'all-users',
}
